import { render } from "./whyus.vue?vue&type=template&id=1b247e8c&scoped=true"
import script from "./whyus.vue?vue&type=script&lang=js"
export * from "./whyus.vue?vue&type=script&lang=js"

import "./whyus.vue?vue&type=style&index=0&id=1b247e8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b247e8c"]])

export default __exports__